import { Navigation, Phone } from "lucide-react";
import { Reveal } from "./Reveal";
import { DIRECTIONS_URL, PHONE_DISPLAY } from "../data";
import { useLang } from "../i18n";

export const Directions = () => {
  const { s } = useLang();
  return (
  <section className="relative overflow-hidden bg-night py-20 sm:py-24 grain" data-testid="directions-section">
    <span
      aria-hidden="true"
      className="pointer-events-none select-none absolute -left-4 top-1/2 -translate-y-1/2 font-hindi text-[18vw] leading-none text-cream/[0.04]"
    >
      मार्ग
    </span>
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 flex flex-col lg:flex-row lg:items-center gap-10 justify-between">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.25em] text-gold font-semibold" data-testid="directions-overline">
          {s.directions.overline}
        </p>
        <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-cream tracking-tight max-w-xl" data-testid="directions-heading">
          {s.directions.heading}
        </h2>
        <p className="mt-4 max-w-lg text-sm sm:text-base leading-relaxed text-cream/65">
          {s.directions.text}
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="flex flex-wrap gap-4">
          <a
            href={DIRECTIONS_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="get-directions-button"
            className="inline-flex items-center gap-2 rounded-full bg-saffron px-8 py-4 text-sm font-bold text-night transition-colors duration-300 hover:bg-gold"
          >
            <Navigation size={17} /> {s.directions.cta}
          </a>
          <a
            href={`tel:${PHONE_DISPLAY.replace(/\s/g, "")}`}
            data-testid="directions-call-button"
            className="inline-flex items-center gap-2 rounded-full border border-cream/30 px-8 py-4 text-sm font-semibold text-cream transition-colors duration-300 hover:border-saffron hover:text-saffron"
          >
            <Phone size={17} /> {PHONE_DISPLAY}
          </a>
        </div>
      </Reveal>
    </div>
  </section>
  );
};
